var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.msg)?_c('div',{staticClass:"alert alert-danger alert-dismissible"},[_vm._v("\n  "+_vm._s(_vm.msg)+"\n  "),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])
}]

export { render, staticRenderFns }